@if (isInitialized) {
  <oe-flat-widget button [title]="component.alias" [icon]="{name:
    'cloud-outline', color: 'normal'}" [modalComponent]="modalComponent">
    <oe-modal-horizontal-line></oe-modal-horizontal-line>
    <oe-flat-widget-line [name]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.PRICE' | translate"
                         [value]="consumptionPriceWithCurrency"></oe-flat-widget-line>
    <oe-flat-widget-line [name]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.PRODUCTION_PRICE' | translate"
                         [value]="productionPriceWithCurrency"></oe-flat-widget-line>

  </oe-flat-widget>
}
